// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/home/hero-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/images/home/our-process-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/images/home/our-process-mobile-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how-it-works-page .how-it-works-page-hero {
  width: 100%;
  min-height: 330px;
  background-color: #040e46;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  border-radius: 20px;
  margin-top: 22px;
  padding: 100px;
}
.how-it-works-page .how-it-works-page-hero .top-block {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}
.how-it-works-page .how-it-works-page-hero .top-block img {
  width: 304px;
  height: 62px;
}
.how-it-works-page .how-it-works-page-hero .top-block .how-it-works-title {
  font-weight: 600;
  font-size: 46px;
  line-height: 120%;
  color: #fff;
}
.how-it-works-page .how-it-works-page-hero .bottom-block {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 24px;
}
.how-it-works-page .how-it-works-page-hero .bottom-block .how-it-works-subtitle {
  font-weight: 400;
  font-size: 22px;
  line-height: 180%;
  color: #fff;
}
.how-it-works-page .how-it-works-page-hero .bottom-block .request-demo-btn {
  background-color: #fff;
  border: none;
  border-bottom: 2px solid #dee1e7;
  border-radius: 8px;
  padding: 12px 24px 12px 24px;
  gap: 8px;
  display: flex;
  align-items: center;
  width: 200px;
  height: 46px;
  color: #448aff;
  font-weight: 600;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
}
.how-it-works-page .our-process-block {
  background-color: #e7f0ff;
  padding: 100px;
  margin-top: 20px;
  border-radius: 20px;
  border: 1px solid #eceef1;
  color: #000;
}
.how-it-works-page .our-process-block .our-process-title {
  font-weight: 400;
  font-size: 40px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
}
.how-it-works-page .our-process-block .our-process-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 46px;
  margin-top: 80px;
}
.how-it-works-page .our-process-block .our-process-list .our-process-item {
  padding: 6px 32px 6px 6px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 6px 10px -4px rgba(68, 138, 255, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(68, 138, 255, 0.2196078431);
  display: flex;
  gap: 28px;
}
.how-it-works-page .our-process-block .our-process-list .our-process-item .left-block {
  position: relative;
  overflow: hidden;
  min-height: 255px;
  width: 154px;
  border-radius: 4px;
  flex-shrink: 0;
}
.how-it-works-page .our-process-block .our-process-list .our-process-item .left-block::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
}
.how-it-works-page .our-process-block .our-process-list .our-process-item .left-block .icon-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background-color: #040e46;
  height: 90px;
  width: 90px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.how-it-works-page .our-process-block .our-process-list .our-process-item .right-block {
  display: flex;
  align-items: center;
}
.how-it-works-page .our-process-block .our-process-list .our-process-item .right-block .right-block-content .right-block-title {
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #448aff;
}
.how-it-works-page .our-process-block .our-process-list .our-process-item .right-block .right-block-content .right-block-text {
  margin-top: 6px;
  color: #040e46;
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
}
.how-it-works-page .core-capabilities {
  padding: 80px;
  background: #fff;
  border: none;
}
.how-it-works-page .core-capabilities .core-capabilities-title {
  font-size: 40px;
  line-height: 120%;
  color: #3571d6;
  text-align: center;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 32px;
  margin-top: 46px;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item {
  position: relative;
  min-height: 260px;
  padding: 112px 36px 36px 36px;
  grid-column: span 4;
  background: linear-gradient(0deg, var(--Greyscale-Grey-5, #f9fafb), var(--Greyscale-Grey-5, #f9fafb)), radial-gradient(50% 161.19% at 50% 100%, rgba(68, 138, 255, 0) 50%, rgba(68, 138, 255, 0.1) 100%);
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item.core-capabilities-item-tall {
  grid-row: span 2;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item.core-capabilities-item-wide {
  grid-column: span 8;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item.core-capabilities-item-semi-wide {
  grid-column: span 6;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item .corner-image-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  text-align: right;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item .corner-image-wrapper svg {
  position: absolute;
  top: 42px;
  right: 42px;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-screenshot-img {
  width: 100%;
  height: 260px;
  background-size: cover;
  position: relative;
  z-index: 2;
  object-fit: cover;
  border-radius: 4px;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-content {
  position: relative;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-content .core-capabilities-item-title {
  color: #040e46;
  font-size: 26px;
  font-weight: 600;
  line-height: 130%;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-content .core-capabilities-item-subtitle {
  margin-top: 12px;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(3) {
  padding: 6px;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(3) .corner-image-wrapper {
  top: 215px;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(3) .core-capabilities-item-content {
  margin-top: 112px;
  margin-left: 36px;
  margin-right: 36px;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(3) .core-capabilities-item-screenshot-img {
  object-position: 0 -125px;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) {
  padding: 6px;
  display: flex;
  gap: 32px;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) .core-capabilities-item-screenshot-wrapper {
  width: calc(50% - 16px);
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) .core-capabilities-item-content {
  margin-top: 112px;
  margin-left: 36px;
  margin-right: 36px;
}
.how-it-works-page .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) .core-capabilities-item-right-block {
  width: calc(50% - 16px);
}
.how-it-works-page .how-it-works-core-benefits {
  padding: 135px 100px 80px 100px;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  z-index: 1;
  border: 1px solid #eceef1;
}
.how-it-works-page .how-it-works-core-benefits::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.35;
  z-index: 0;
  border-radius: 20px;
  mix-blend-mode: luminosity;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-title {
  color: #000;
  font-size: 40px;
  text-align: center;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider {
  margin-top: 80px;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .swiper {
  padding-bottom: 3rem;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .swiper .swiper-button-next,
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .swiper .swiper-button-prev {
  display: none;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .swiper .swiper-pagination-bullet {
  background: #fff;
  width: 10px;
  height: 10px;
  opacity: 1;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .swiper .swiper-pagination-bullet-active {
  background: #4b6fff;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .custom-nav {
  display: flex;
  justify-content: space-between;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .custom-nav button {
  position: relative;
  z-index: 10;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s;
  color: #3571d6;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .custom-nav button:hover {
  background-color: #f5f5f5;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .how-it-works-core-benefits-slide {
  position: relative;
  border-radius: 1rem;
  text-align: center;
  height: 270px;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .how-it-works-core-benefits-slide .how-it-works-core-benefits-slide-content {
  background-color: #fff;
  border-radius: 10px;
  height: 240px;
  padding: 80px 28px;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .how-it-works-core-benefits-slide .how-it-works-core-benefits-slide-content .how-it-works-core-benefits-title {
  color: #3571d6;
  font-size: 28px;
  font-weight: 600;
  line-height: 130%;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .how-it-works-core-benefits-slide .how-it-works-core-benefits-slide-content .how-it-works-core-benefits-subtitle {
  color: #445169;
  font-size: 20px;
  font-weight: 400;
  line-height: 150%;
  margin-top: 12px;
}
.how-it-works-page .how-it-works-core-benefits .how-it-works-core-benefits-slider .how-it-works-core-benefits-slide .icon-wrapper {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  height: 90px;
  width: 90px;
  background-color: #3571d6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.how-it-works-page.isMobile .home-page-content .how-it-works-page-hero {
  padding: 48px 20px 20px 20px;
}
.how-it-works-page.isMobile .home-page-content .how-it-works-page-hero .top-block {
  display: block;
  text-align: center;
}
.how-it-works-page.isMobile .home-page-content .how-it-works-page-hero .top-block .how-it-works-how-title {
  font-size: 32px;
  font-weight: 600;
  line-height: 120%;
  color: #fff;
  margin-bottom: 2px;
}
.how-it-works-page.isMobile .home-page-content .how-it-works-page-hero .top-block .how-it-works-works-title {
  margin-top: 2px;
  font-size: 32px;
  font-weight: 600;
  line-height: 120%;
  color: #fff;
}
.how-it-works-page.isMobile .home-page-content .how-it-works-page-hero .bottom-block {
  display: block;
  padding-left: 20px;
  padding-right: 20px;
}
.how-it-works-page.isMobile .home-page-content .how-it-works-page-hero .bottom-block .how-it-works-subtitle {
  font-weight: 400;
  font-size: 20px;
  line-height: 160%;
  text-align: center;
}
.how-it-works-page.isMobile .home-page-content .how-it-works-page-hero .bottom-block .request-demo-btn {
  margin-top: 28px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 150%;
}
.how-it-works-page.isMobile .home-page-content .our-process-block {
  padding: 40px 20px;
  margin-top: 10px;
}
.how-it-works-page.isMobile .home-page-content .our-process-block .our-process-title {
  font-size: 32px;
}
.how-it-works-page.isMobile .home-page-content .our-process-block .our-process-list {
  margin-top: 32px;
  display: block;
}
.how-it-works-page.isMobile .home-page-content .our-process-block .our-process-list .our-process-item {
  margin-top: 16px;
  display: block;
  box-shadow: 0px 6px 10px -4px rgba(68, 138, 255, 0.1);
  box-shadow: 0px 18px 32px -4px rgba(68, 138, 255, 0.22);
  padding: 6px 6px 28px 6px;
}
.how-it-works-page.isMobile .home-page-content .our-process-block .our-process-list .our-process-item .left-block {
  width: 100%;
  height: 96px;
  min-height: unset;
}
.how-it-works-page.isMobile .home-page-content .our-process-block .our-process-list .our-process-item .left-block::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.how-it-works-page.isMobile .home-page-content .our-process-block .our-process-list .our-process-item .left-block .icon-wrapper {
  height: 60px;
  width: 60px;
}
.how-it-works-page.isMobile .home-page-content .our-process-block .our-process-list .our-process-item .left-block .icon-wrapper img {
  height: 36px;
  width: 36px;
}
.how-it-works-page.isMobile .home-page-content .our-process-block .our-process-list .our-process-item .right-block {
  padding: 24px 18px 0px 18px;
}
.how-it-works-page.isMobile .home-page-content .our-process-block .our-process-list .our-process-item .right-block .right-block-text {
  font-size: 20px;
}
.how-it-works-page.isMobile .home-page-content .reviews-block {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/subpages/HowItWorks/styles.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,iBAAA;EAEA,yBAAA;EACA,yDAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAGI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AADN;AAGM;EACE,YAAA;EACA,YAAA;AADR;AAIM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAFR;AAMI;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,gBAAA;AAJN;AAMM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAJR;AAOM;EACE,sBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,4BAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,4DAAA;EACA,6DAAA;AALR;AAUE;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;AARJ;AAUI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AARN;AAWI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,gBAAA;AATN;AAWM;EACE,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,8DAAA;EACA,+DAAA;EACA,aAAA;EACA,SAAA;AATR;AAWQ;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AATV;AAWU;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;AATZ;AAYU;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAVZ;AAcQ;EACE,aAAA;EACA,mBAAA;AAZV;AAeY;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAbd;AAgBY;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAdd;AAsBE;EACE,aAAA;EACA,gBAAA;EACA,YAAA;AApBJ;AAsBI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AApBN;AAuBI;EACE,aAAA;EACA,sCAAA;EACA,SAAA;EACA,gBAAA;AArBN;AAuBM;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,mBAAA;EACA,wMAAA;AArBR;AAwBQ;EACE,gBAAA;AAtBV;AAyBQ;EACE,mBAAA;AAvBV;AA0BQ;EACE,mBAAA;AAxBV;AA2BQ;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,iBAAA;AAzBV;AA2BU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAzBZ;AA6BQ;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AA3BV;AA8BQ;EACE,kBAAA;AA5BV;AA8BU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA5BZ;AA+BU;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA7BZ;AAiCQ;EACE,YAAA;AA/BV;AAiCU;EACE,UAAA;AA/BZ;AAkCU;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AAhCZ;AAmCU;EACE,yBAAA;AAjCZ;AAqCQ;EACE,YAAA;EACA,aAAA;EACA,SAAA;AAnCV;AAqCU;EACE,uBAAA;AAnCZ;AAsCU;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AApCZ;AAuCU;EACE,uBAAA;AArCZ;AA4CE;EACE,+BAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AA1CJ;AA4CI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,0BAAA;AA1CN;AA6CI;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AA3CN;AA8CI;EACE,gBAAA;AA5CN;AA8CM;EACE,oBAAA;AA5CR;AA8CQ;;EAEE,aAAA;AA5CV;AA+CQ;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA7CV;AAgDQ;EACE,mBAAA;AA9CV;AAkDM;EACE,aAAA;EACA,8BAAA;AAhDR;AAkDQ;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yCAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AAhDV;AAiDU;EACE,yBAAA;AA/CZ;AAoDM;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAlDR;AAoDQ;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAlDV;AAoDU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAlDZ;AAqDU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAnDZ;AAuDQ;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArDV;;AA8DI;EACE,4BAAA;AA3DN;AA6DM;EACE,cAAA;EACA,kBAAA;AA3DR;AA6DQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AA3DV;AA8DQ;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AA5DV;AAgEM;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AA9DR;AAgEQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA9DV;AAiEQ;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AA/DV;AAoEI;EACE,kBAAA;EACA,gBAAA;AAlEN;AAoEM;EACE,eAAA;AAlER;AAqEM;EACE,gBAAA;EACA,cAAA;AAnER;AAqEQ;EACE,gBAAA;EACA,cAAA;EACA,qDAAA;EACA,uDAAA;EACA,yBAAA;AAnEV;AAqEU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAnEZ;AAqEY;EACE,yDAAA;AAnEd;AAsEY;EACE,YAAA;EACA,WAAA;AApEd;AAsEc;EACE,YAAA;EACA,WAAA;AApEhB;AAyEU;EACE,2BAAA;AAvEZ;AAyEY;EACE,eAAA;AAvEd;AA8EI;EACE,gBAAA;AA5EN","sourcesContent":[".how-it-works-page {\n  .how-it-works-page-hero {\n    width: 100%;\n    min-height: 330px;\n\n    background-color: #040e46;\n    background-image: url('../../../../assets/images/home/hero-bg.png');\n    background-size: cover;\n    border-radius: 20px;\n    margin-top: 22px;\n    padding: 100px;\n\n    .top-block {\n      display: flex;\n      align-items: flex-start;\n      gap: 24px;\n\n      img {\n        width: 304px;\n        height: 62px;\n      }\n\n      .how-it-works-title {\n        font-weight: 600;\n        font-size: 46px;\n        line-height: 120%;\n        color: #fff;\n      }\n    }\n\n    .bottom-block {\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n      margin-top: 24px;\n\n      .how-it-works-subtitle {\n        font-weight: 400;\n        font-size: 22px;\n        line-height: 180%;\n        color: #fff;\n      }\n\n      .request-demo-btn {\n        background-color: #fff;\n        border: none;\n        border-bottom: 2px solid #dee1e7;\n        border-radius: 8px;\n        padding: 12px 24px 12px 24px;\n        gap: 8px;\n        display: flex;\n        align-items: center;\n        width: 200px;\n        height: 46px;\n        color: #448aff;\n        font-weight: 600;\n        box-shadow: 0px 6px 10px -4px #0f17281a;\n        box-shadow: 0px 18px 32px -4px #0f172838;\n      }\n    }\n  }\n\n  .our-process-block {\n    background-color: #e7f0ff;\n    padding: 100px;\n    margin-top: 20px;\n    border-radius: 20px;\n    border: 1px solid #eceef1;\n    color: #000;\n\n    .our-process-title {\n      font-weight: 400;\n      font-size: 40px;\n      line-height: 120%;\n      letter-spacing: 0%;\n      text-align: center;\n    }\n\n    .our-process-list {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 46px;\n      margin-top: 80px;\n\n      .our-process-item {\n        padding: 6px 32px 6px 6px;\n        background-color: #fff;\n        border-radius: 10px;\n        box-shadow: 0px 6px 10px -4px #448aff1a;\n        box-shadow: 0px 18px 32px -4px #448aff38;\n        display: flex;\n        gap: 28px;\n\n        .left-block {\n          position: relative;\n          overflow: hidden;\n          min-height: 255px;\n          width: 154px;\n          border-radius: 4px;\n          flex-shrink: 0;\n\n          &::before {\n            content: '';\n            position: absolute;\n            inset: 0;\n            background-image: url('../../../../assets/images/home/our-process-bg.png');\n            background-size: cover;\n            background-position: center;\n          }\n\n          .icon-wrapper {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n            z-index: 1;\n            background-color: #040e46;\n            height: 90px;\n            width: 90px;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n\n        .right-block {\n          display: flex;\n          align-items: center;\n\n          .right-block-content {\n            .right-block-title {\n              font-weight: 500;\n              font-size: 16px;\n              line-height: 150%;\n              color: #448aff;\n            }\n\n            .right-block-text {\n              margin-top: 6px;\n              color: #040e46;\n              font-weight: 500;\n              font-size: 24px;\n              line-height: 130%;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .core-capabilities {\n    padding: 80px;\n    background: #fff;\n    border: none;\n\n    .core-capabilities-title {\n      font-size: 40px;\n      line-height: 120%;\n      color: #3571d6;\n      text-align: center;\n    }\n\n    .core-capabilities-grid-container {\n      display: grid;\n      grid-template-columns: repeat(12, 1fr);\n      gap: 32px;\n      margin-top: 46px;\n\n      .core-capabilities-item {\n        position: relative;\n        min-height: 260px;\n        padding: 112px 36px 36px 36px;\n        grid-column: span 4;\n        background: linear-gradient(0deg, var(--Greyscale-Grey-5, #f9fafb), var(--Greyscale-Grey-5, #f9fafb)),\n          radial-gradient(50% 161.19% at 50% 100%, rgba(68, 138, 255, 0) 50%, rgba(68, 138, 255, 0.1) 100%);\n\n        &.core-capabilities-item-tall {\n          grid-row: span 2;\n        }\n\n        &.core-capabilities-item-wide {\n          grid-column: span 8;\n        }\n\n        &.core-capabilities-item-semi-wide {\n          grid-column: span 6;\n        }\n\n        .corner-image-wrapper {\n          position: absolute;\n          right: 0;\n          top: 0;\n          text-align: right;\n\n          svg {\n            position: absolute;\n            top: 42px;\n            right: 42px;\n          }\n        }\n\n        .core-capabilities-item-screenshot-img {\n          width: 100%;\n          height: 260px;\n          background-size: cover;\n          position: relative;\n          z-index: 2;\n          object-fit: cover;\n          border-radius: 4px;\n        }\n\n        .core-capabilities-item-content {\n          position: relative;\n\n          .core-capabilities-item-title {\n            color: #040e46;\n            font-size: 26px;\n            font-weight: 600;\n            line-height: 130%;\n          }\n\n          .core-capabilities-item-subtitle {\n            margin-top: 12px;\n            font-weight: 400;\n            font-size: 18px;\n            line-height: 150%;\n          }\n        }\n\n        &:nth-child(3) {\n          padding: 6px;\n\n          .corner-image-wrapper {\n            top: 215px;\n          }\n\n          .core-capabilities-item-content {\n            margin-top: 112px;\n            margin-left: 36px;\n            margin-right: 36px;\n          }\n\n          .core-capabilities-item-screenshot-img {\n            object-position: 0 -125px;\n          }\n        }\n\n        &:nth-child(4) {\n          padding: 6px;\n          display: flex;\n          gap: 32px;\n\n          .core-capabilities-item-screenshot-wrapper {\n            width: calc(50% - 16px);\n          }\n\n          .core-capabilities-item-content {\n            margin-top: 112px;\n            margin-left: 36px;\n            margin-right: 36px;\n          }\n\n          .core-capabilities-item-right-block {\n            width: calc(50% - 16px);\n          }\n        }\n      }\n    }\n  }\n\n  .how-it-works-core-benefits {\n    padding: 135px 100px 80px 100px;\n    width: 100%;\n    border-radius: 20px;\n    overflow: hidden;\n    position: relative;\n    z-index: 1;\n    border: 1px solid #eceef1;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-image: url('../../../../assets/images/home/hero-bg.png');\n      background-size: cover;\n      background-repeat: no-repeat;\n      background-position: center;\n      opacity: 0.35;\n      z-index: 0;\n      border-radius: 20px;\n      mix-blend-mode: luminosity;\n    }\n\n    .how-it-works-core-benefits-title {\n      color: #000;\n      font-size: 40px;\n      text-align: center;\n    }\n\n    .how-it-works-core-benefits-slider {\n      margin-top: 80px;\n\n      .swiper {\n        padding-bottom: 3rem;\n\n        .swiper-button-next,\n        .swiper-button-prev {\n          display: none;\n        }\n\n        .swiper-pagination-bullet {\n          background: #fff;\n          width: 10px;\n          height: 10px;\n          opacity: 1;\n        }\n\n        .swiper-pagination-bullet-active {\n          background: #4b6fff;\n        }\n      }\n\n      .custom-nav {\n        display: flex;\n        justify-content: space-between;\n\n        button {\n          position: relative;\n          z-index: 10;\n          width: 48px;\n          height: 48px;\n          border-radius: 50%;\n          background-color: #fff;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          border: none;\n          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n          cursor: pointer;\n          transition: all 0.2s;\n          color: #3571d6;\n          &:hover {\n            background-color: #f5f5f5;\n          }\n        }\n      }\n\n      .how-it-works-core-benefits-slide {\n        position: relative;\n        border-radius: 1rem;\n        text-align: center;\n        height: 270px;\n\n        .how-it-works-core-benefits-slide-content {\n          background-color: #fff;\n          border-radius: 10px;\n          height: 240px;\n          padding: 80px 28px;\n\n          .how-it-works-core-benefits-title {\n            color: #3571d6;\n            font-size: 28px;\n            font-weight: 600;\n            line-height: 130%;\n          }\n\n          .how-it-works-core-benefits-subtitle {\n            color: #445169;\n            font-size: 20px;\n            font-weight: 400;\n            line-height: 150%;\n            margin-top: 12px;\n          }\n        }\n\n        .icon-wrapper {\n          position: absolute;\n          top: 0;\n          left: 50%;\n          transform: translate(-50%, 0);\n          height: 90px;\n          width: 90px;\n          background-color: #3571d6;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n      }\n    }\n  }\n}\n\n.how-it-works-page.isMobile {\n  .home-page-content {\n    .how-it-works-page-hero {\n      padding: 48px 20px 20px 20px;\n\n      .top-block {\n        display: block;\n        text-align: center;\n\n        .how-it-works-how-title {\n          font-size: 32px;\n          font-weight: 600;\n          line-height: 120%;\n          color: #fff;\n          margin-bottom: 2px;\n        }\n\n        .how-it-works-works-title {\n          margin-top: 2px;\n          font-size: 32px;\n          font-weight: 600;\n          line-height: 120%;\n          color: #fff;\n        }\n      }\n\n      .bottom-block {\n        display: block;\n        padding-left: 20px;\n        padding-right: 20px;\n\n        .how-it-works-subtitle {\n          font-weight: 400;\n          font-size: 20px;\n          line-height: 160%;\n          text-align: center;\n        }\n\n        .request-demo-btn {\n          margin-top: 28px;\n          width: 100%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 16px;\n          line-height: 150%;\n        }\n      }\n    }\n\n    .our-process-block {\n      padding: 40px 20px;\n      margin-top: 10px;\n\n      .our-process-title {\n        font-size: 32px;\n      }\n\n      .our-process-list {\n        margin-top: 32px;\n        display: block;\n\n        .our-process-item {\n          margin-top: 16px;\n          display: block;\n          box-shadow: 0px 6px 10px -4px rgba(68, 138, 255, 0.1);\n          box-shadow: 0px 18px 32px -4px rgba(68, 138, 255, 0.22);\n          padding: 6px 6px 28px 6px;\n\n          .left-block {\n            width: 100%;\n            height: 96px;\n            min-height: unset;\n\n            &::before {\n              background-image: url('../../../../assets/images/home/our-process-mobile-bg.png');\n            }\n\n            .icon-wrapper {\n              height: 60px;\n              width: 60px;\n\n              img {\n                height: 36px;\n                width: 36px;\n              }\n            }\n          }\n\n          .right-block {\n            padding: 24px 18px 0px 18px;\n\n            .right-block-text {\n              font-size: 20px;\n            }\n          }\n        }\n      }\n    }\n\n    .reviews-block {\n      margin-top: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
